import script from "./TabSelectionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TabSelectionButton.vue?vue&type=script&setup=true&lang=js"

import "./TabSelectionButton.vue?vue&type=style&index=0&id=520a0a9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520a0a9f"]])

export default __exports__